<template>
  <v-app-bar
    app
    color="primary"
    dark
    :class="containerClass"
    style="z-index:50;"
    id="navi"
  >
    <div class="d-flex align-center" id="navi2">
      <div
        v-if="showMobileView"
        class="d-flex justify-space-between align-center"
        style="width:95vw;"
      >
        <div class="d-flex">
          <v-icon
            @click="drawer = !drawer"
            v-if="showMobileView"
            color="secondary"
            class="pr-3"
            >mdi-menu</v-icon
          >
          <v-card-text class="text-uppercase font-weight-bold">
            {{ currentPage }}
          </v-card-text>
        </div>
        <span
          @click="goBack()"
          v-if="showMobileView && needsGoBack"
          color="secondary"
          class="pr-3"
          >Back to {{ goBackText }}</span
        >
      </div>
      <v-img
        contain
        v-if="!showMobileView"
        height="45"
        width="100"
        :src="logoUrl"
        id="homepage-logo"
      />
      <div
        v-if="!showMobileView"
        class="d-flex pl-8 justify-space-between"
        style="height:50px; width: 88vw;"
      >
        <div class="d-flex">
          <template v-for="(item, index) in newNavList">
            <v-list-item
              v-if="item.ifLoggedIn === loggedIn && item.title !== 'Log Out'"
              :to="item.to"
              :href="item.href"
              :key="index"
              :id="
                'nav-' +
                  item.title
                    .toLowerCase()
                    .split(' ')
                    .join('-')
              "
              class="d-flex justify-center"
              style="font-size: 20px; min-width: fit-content"
              @click="checkLogOut(item.title)"
            >
              <v-list-item-content
                color="secondary"
                :style="textStyle"
                class="font-weight-bold d-flex justify-center"
              >
                {{ item.title }}
              </v-list-item-content>
            </v-list-item>
          </template>
        </div>
        <div class="d-flex justify-center align-center" v-if="loggedIn">
          <div style="z-index:500;" v-if="currentUser.client_id.length > 1">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  text
                  v-bind="attrs"
                  v-on="on"
                  id="client-dropdown-button"
                >
                  <v-icon
                    v-if="$vuetify.theme.currentTheme.primary === '#FFFFFF'"
                    color="black"
                    >mdi-dots-vertical</v-icon
                  >
                  <v-icon
                    v-if="$vuetify.theme.currentTheme.primary !== '#FFFFFF'"
                    color="white"
                    >mdi-dots-vertical</v-icon
                  >
                </v-btn>
              </template>
              <v-list id="client-dropdown">
                <v-list-item
                  v-for="(item, index) in clientList"
                  :key="index"
                  :id="'client-' + item.toLowerCase()"
                  @click="changeCurrentClient(item)"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <template>
            <v-list-item
              block
              class="font-weight-bold"
              style="font-size: 24px"
              id="account-route"
              :to="accountRoute"
            >
              <v-list-item-avatar color="black" class="ml-1 white--text">{{
                initials
              }}</v-list-item-avatar></v-list-item
            >
          </template>
        </div>
      </div>
    </div>
    <v-navigation-drawer
      v-if="showMobileView"
      app
      v-model="drawer"
      disable-resize-watcher
      temporary
      color="primary"
      overlay-opacity="0.9"
      dark
      width="300"
      style="z-index: 1 !important"
    >
      <v-list>
        <template v-for="(item, index) in newNavList">
          <v-list-item
            v-if="item.ifLoggedIn === loggedIn"
            :to="item.to"
            :href="item.href"
            :key="index"
            class="pl-6"
            :style="textStyle"
            style="font-size: 24px;"
            @click="checkLogOut(item.title)"
          >
            <v-list-item-content color="secondary" class="font-weight-bold">
              {{ item.title }}
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <template v-if="loggedIn">
        <v-list-item
          block
          class="font-weight-bold mt-15"
          style="font-size: 24px"
          :style="textStyle"
          :to="accountRoute"
        >
          <v-list-item-avatar color="black" class="ml-1 white--text">{{
            initials
          }}</v-list-item-avatar
          >{{ currentUser.user_name }}</v-list-item
        >
      </template>
      <template
        v-if="loggedIn && currentUser.client_id.length > 1"
        v-slot:append
        style="color: white;"
      >
        <v-col class="d-flex" cols="20" style="color:black; z-index:500;">
          <v-select
            solo
            flat
            background-color="black"
            :items="currentUser.client_id"
            @input="selectClient()"
            v-model="selectedClient"
          >
            <template v-slot:append>
              <v-icon color="primary">mdi-chevron-down</v-icon>
            </template></v-select
          >
        </v-col>
      </template>
    </v-navigation-drawer>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { MobileView } from '@/mixins';

export default {
  name: 'NavigationComp',
  data: () => ({
    drawer: false,
    selectedClient: '',
    logo_url: '',
    needsGoBack: false,
    goBackText: 'Screens',
  }),
  mixins: [MobileView],
  computed: {
    ...mapGetters({
      currentClient: 'account/getCurrentClient',
      currentUser: 'account/getCurrentUser',
      navigationList: 'navigation/getNavigationList',
      loggedIn: 'auth/getIsLoggedIn',
      _allClients: 'account/getAllClients',
      clientLogo: 'account/getClientLogo',
    }),
    accountRoute() {
      if (this.currentClient.client_name) {
        return `/${this.currentClient.client_name
          .toLowerCase()
          .replace(/\s/g, '')}/account`;
      }
      return '/account';
    },
    currentPage() {
      switch (this.$route.name) {
        case 'Groups':
        case 'Groups Details':
          if (this.currentClient.client_name === 'shark') {
            return 'Courses';
          }
          return 'Groups';

        case 'Screens':
          if (this.currentClient.client_name === 'shark') {
            return 'Golf Cars';
          }
          return 'Screens';

        case 'Screens Details':
          if (this.currentClient.client_name === 'shark') {
            return 'Golf Cart Details';
          }
          return 'Screen Details';

        case 'Devices':
          if (this.currentClient.client_name === 'shark') {
            return 'Course Locations';
          }
          return 'Devices';

        default:
          return this.$route.name;
      }
    },
    logoUrl() {
      if (this.loggedIn) {
        if (this.currentClient.client_name === 'avis') {
          return require('../../assets/AVIS.png');
        }
        if (this.currentClient.client_name === 'bazzbi') {
          return require('../../assets/bazzbi.png');
        }
        return require('../../assets/sharklogo.png');
      }
      return require('../../assets/edison_logo.png');
    },
    logoSrc() {
      if (this.loggedIn) {
        return this.clientLogo;
      }
      return '';
    },
    initials() {
      if (this.currentUser.user_name) {
        const first = this.currentUser.user_name[0];
        const initials = `${first}`;
        return initials.toUpperCase();
      }
      return '';
    },
    containerClass() {
      if (this.showMobileView) {
        return 'd-flex justify-start width:100vw;';
      }
      return 'd-flex justify-center';
    },
    newNavList() {
      if (this.currentClient.client_name === 'avis') {
        return this.navigationList.filter(
          navItem => navItem.title !== 'Key Codes'
        );
      }
      if (this.currentClient.client_name === 'bazzbi') {
        return this.navigationList.filter(
          navItem =>
            navItem.title !== 'Reconciliation' && navItem.title !== 'Reports'
        );
      }
      if (this.currentClient.client_name === 'shark') {
        return this.navigationList.filter(
          navItem =>
            navItem.title !== 'Reconciliation' && navItem.title !== 'Key Codes'
        );
      }
      return this.navigationList.filter(
        navItem =>
          navItem.title !== 'Reconciliation' && navItem.title !== 'Key Codes'
      );
    },
    textStyle() {
      if (this.$vuetify.theme.currentTheme.primary !== '#FFFFFF') {
        return 'color: white !important;';
      }
      return 'color: black !important;';
    },
    clientList() {
      const clients = [];
      this.currentUser.client_id.map(client => {
        clients.push(client.charAt(0).toUpperCase() + client.slice(1));
      });
      return clients;
    },
  },
  methods: {
    ...mapMutations({
      setCurrentClient: 'account/setCurrentClient',
    }),
    ...mapActions({
      logOut: 'auth/logOut',
      _changeClient: 'account/changeClient',
    }),
    getGoBack() {
      if (this.$router.history.current.name === 'Screens Details') {
        if (this.currentClient.client_name === 'shark') {
          this.goBackText = 'Golf Carts';
        } else {
          this.goBackText = 'Screens';
        }
        this.needsGoBack = true;
      } else if (this.$router.history.current.name === 'Groups Details') {
        this.needsGoBack = true;
        if (this.currentClient.client_name === 'shark') {
          this.goBackText = 'Courses';
        } else {
          this.goBackText = 'Groups';
        }
      } else {
        this.needsGoBack = false;
      }
    },
    checkLogOut(title) {
      if (title === 'Log Out') {
        this.logOut();
      }
    },
    changeCurrentClient(client) {
      this.selectedClient = client;
      this._changeClient(this.selectedClient);
    },
    selectClient() {
      this._changeClient(this.selectedClient);
    },
    goBack() {
      if (this.$router.history.current.name === 'Screens Details') {
        this.$router.push(
          `/${this.currentClient.client_name
            .toLowerCase()
            .replace(/\s/g, '')}/screens`
        );
      } else if (this.$router.history.current.name === 'Groups Details') {
        this.$router.push(
          `/${this.currentClient.client_name
            .toLowerCase()
            .replace(/\s/g, '')}/groups`
        );
      }
    },
  },
  watch: {
    currentClient: {
      handler() {
        this.selectedClient = this.currentClient.client_name;
        this.logo_url = this.currentClient.logo_url;
        if (this.currentClient.client_name === 'shark') {
          this.newNavList[2].title = 'Courses';
          this.newNavList[1].title = 'Golf Cars';
          this.newNavList[4].title = 'Course Locations';
        } else {
          this.newNavList[2].title = 'Groups';
          this.newNavList[1].title = 'Screens';
          this.newNavList[5].title = 'Device Locations';
        }
      },
      deep: true,
    },
    '$route.history.current.name': {
      handler() {
        this.getGoBack();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.v-input {
  font-size: 24px;
  font-weight: bold;
}
</style>
<style>
.v-select__selections {
  line-height: 30px !important;
}
</style>
